import { translateString } from "../translations/gridTranslationHelper";
import { Culture } from "../types/culture";

const getWorkorderStatus = (statusId: number, culture: Culture) => {
    if (statusId === 0) return translateString("woSPlanned", culture);
    else if (statusId === 1) return translateString("woSApproved", culture);
    else if (statusId === 2) return translateString("woSInUse", culture);
    else if (statusId === 3) return translateString("woSSuspended", culture);
    else if (statusId === 4) return translateString("woSClosed", culture);
};

const renderPalletStatusTranslation = (statusId: number, culture: Culture) => {
    if (statusId === -1) return translateString("status", culture);
    else if (statusId === 0) return translateString("palletStatusId00", culture);
    else if (statusId === 1) return translateString("palletStatusId01", culture);
    else if (statusId === 2) return translateString("palletStatusId02", culture);
    else if (statusId === 3) return translateString("palletStatusId03", culture);
    else if (statusId === 4) return translateString("palletStatusId04", culture);
    else if (statusId === 5) return translateString("palletStatusId05", culture);
    else if (statusId === 6) return translateString("palletStatusId06", culture);
    else if (statusId === 7) return translateString("palletStatusId07", culture);
    else if (statusId === 8) return translateString("palletStatusId08", culture);
    else if (statusId === 9) return translateString("palletStatusId09", culture);
    else if (statusId === 10) return translateString("palletStatusId10", culture);
    else if (statusId === 11) return translateString("palletStatusId11", culture);
    else if (statusId === 12) return translateString("palletStatusId12", culture);
    else if (statusId === 13) return translateString("palletStatusId13", culture);
    else if (statusId === 14) return translateString("palletStatusId14", culture);
    else if (statusId === 15) return translateString("palletStatusId15", culture);
    else if (statusId === 16) return translateString("palletStatusId16", culture);
    else if (statusId === 17) return translateString("palletStatusId17", culture);
    else if (statusId === 18) return translateString("palletStatusId18", culture);
    else if (statusId === 19) return translateString("palletStatusId19", culture);
    else if (statusId === 20) return translateString("palletStatusId20", culture);
    else if (statusId === 21) return translateString("palletStatusId21", culture);
    else if (statusId === 22) return translateString("palletStatusId22", culture);
    else if (statusId === 30) return translateString("palletStatusId30", culture);
    else if (statusId === 90) return translateString("palletStatusId90", culture);
    else return `StatusId-${statusId}`;
};

const renderPalletStatus = (statusId: number, culture: Culture) => {
    let sapCode = statusSapCode(statusId);
    if (sapCode === "") return renderPalletStatusTranslation(statusId, culture);
    return `${renderPalletStatusTranslation(statusId, culture)} (${sapCode})`;
};

const renderPalletConditionTranslation = (conditionId: number, culture: Culture) => {
    if (conditionId === -1) return translateString("condition", culture);
    else if (conditionId === 0) return translateString("palletConditionId00", culture);
    else if (conditionId === 1) return translateString("palletConditionId01", culture);
    else if (conditionId === 2) return translateString("palletConditionId02", culture);
    else if (conditionId === 3) return translateString("palletConditionId03", culture);
    else if (conditionId === 4) return translateString("palletConditionId04", culture);
    else if (conditionId === 5) return translateString("palletConditionId05", culture);
    else if (conditionId === 6) return translateString("palletConditionId06", culture);
    else if (conditionId === 7) return translateString("palletConditionId07", culture);
    else if (conditionId === 8) return translateString("palletConditionId08", culture);
    else if (conditionId === 9) return translateString("palletConditionId09", culture);
    else if (conditionId === 10) return translateString("palletConditionId10", culture);
    else if (conditionId === 11) return translateString("palletConditionId11", culture);
    else if (conditionId === 12) return translateString("palletConditionId12", culture);
    else if (conditionId === 13) return translateString("palletConditionId13", culture);
    else if (conditionId === 94) return translateString("palletConditionId94", culture);
    else if (conditionId === 99) return translateString("palletConditionId99", culture);
    else return `ConditionId-${conditionId}`;
};

const renderPalletCondition = (conditionId: number, culture: Culture) =>
    conditionId === -1
        ? translateString("condition", culture)
        : `${renderPalletConditionTranslation(conditionId, culture)} (${conditionSapCode(conditionId)})`;

const statusSapCode = (statusId: number) => {
    if (statusId === 3) return "0600";
    if (statusId === 4) return "0000";
    if (statusId === 5) return "0800";
    if (statusId === 7) return "1000";
    if (statusId === 8) return "0700";
    if (statusId === 9) return "0900";
    if (statusId === 10) return "0300";
    if (statusId === 11) return "0200";
    if (statusId === 12) return "0500";
    if (statusId === 17) return "0000";
    if (statusId === 30) return "0400";
    return "";
};

const conditionSapCode = (conditionId: number | null) => conditionId == null ? "" : conditionId.toFixed(0).padStart(2, "0");

const renderMovementType = (movementTypeId: number, culture: Culture) => {
    let movementTranslationString = `movementDescription${movementTypeId.toString().padStart(2, "0")}`;
    return translateString(movementTranslationString, culture);
};

export { getWorkorderStatus, renderPalletStatus, renderPalletCondition, renderMovementType, statusSapCode, conditionSapCode };
